<template>
  <div>
    <el-Form
      ref="userForm"
      :model="userForm"
      label-width="80px"
      :rules="userRules"
      :inline="true"
      size="small"
    >
      <el-Form-item label="姓名" prop="realName">
        <el-input v-model="userForm.realName"></el-input>
      </el-Form-item>
      <el-Form-item label="联系手机" prop="phone">
        <el-input v-model="userForm.phone"></el-input>
      </el-Form-item>
      <el-Form-item label="岗位" prop="job">
        <el-input v-model="userForm.job"></el-input>
      </el-Form-item>
      <el-Form-item label="性别" prop="sex">
        <el-radio-group v-model="userForm.sex">
          <el-radio :label="1">男</el-radio>
          <el-radio :label="2">女</el-radio>
        </el-radio-group>
      </el-Form-item>
      <el-Form-item label="角色" prop="roles">
        <el-select
          multiple
          v-model="userForm.roles"
          filterable
          placeholder="请选择"
          style="width: 200px"
          :popper-append-to-body="false"
        >
          <el-option
            v-for="item in roleList"
            :key="item.roleId"
            :label="item.roleName"
            :value="item.roleId"
          >
            <div style="display: flex; justify-content: space-between;">
              <span style="margin-right: 3px">{{
                item.roleName
              }}</span>
              <span style="color: #8492a6; font-size: 13px">{{
                item.roleDesc
              }}</span>
            </div>
            
          </el-option>
        </el-select>
      </el-Form-item>
      <el-Form-item label="出生日期" prop="birthDay">
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="userForm.birthDay"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-Form-item>
      <el-Form-item label="所属部门" prop="deptId">
        <el-select
          v-model="userForm.deptId"
          filterable
          placeholder="请选择"
          :popper-append-to-body="false"
          style="width: 200px"
        >
          <el-option
            v-for="item in deptList"
            :key="item.deptId"
            :label="item.deptName"
            :value="item.deptId"
          >
          </el-option>
        </el-select>
      </el-Form-item>
      <el-Form-item label="入职日期" prop="entryTime">
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="userForm.entryTime"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-Form-item>
      <el-form-item label="已请年假" prop="requestLeaveAnnual">
        <el-input v-model="userForm.requestLeaveAnnual" disabled></el-input>
      </el-form-item>
      <el-form-item label="剩余年假" prop="remainLeaveAnnual">
        <el-input v-model="userForm.remainLeaveAnnual" disabled></el-input>
      </el-form-item>
      <el-Form-item label="类型" prop="userStatus">
        <el-radio-group v-model="userForm.userStatus" style="width: 200px;">
          <el-radio :label="1">正式</el-radio>
          <el-radio :label="2">试用</el-radio>
        </el-radio-group>
      </el-Form-item>

      <el-Form-item v-if="userForm.userStatus != 1" label="转正日期" prop="regularDate">
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="userForm.regularDate"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-Form-item>

      <div style="margin: 30px auto; width: 200px">
        <el-Form-item>
          <el-button type="primary" @click="onSubmit">立即提交</el-button>
          <el-button @click="closeWindow">取消</el-button>
        </el-Form-item>
      </div>
    </el-Form>
  </div>
</template>

<script>
import { requestSaveSysUser, requestAllDept, requestRoleList} from "@/api";
export default {
  name: "UserEdit",
  props: ["userForm"],
  data() {
    let isMobileNumber = (rule, value, callback) => {
      if (!value) {
        return new Error("请输入手机号");
      } else {
        const reg = /^1[3-9]\d{9}$/;
        const isPhone = reg.test(value);
        value = Number(value); //转换为数字
        if (typeof value === "number" && !isNaN(value)) {
          //判断是否为数字
          value = value.toString(); //转换成字符串
          if (value.length < 0 || value.length > 12 || !isPhone) {
            //判断是否为11位手机号
            callback(new Error("手机号码格式如:138xxxx8754"));
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入手机号"));
        }
      }
    };
    return {
      userRules: {
        realName: [
          { required: true, message: "请输入姓名", trigger: "change" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "change",
          },
        ],
        phone: [
          { required: true, message: "请输入联系手机", trigger: "change" },
          { validator: isMobileNumber, trigger: "change" },
        ],
        job: [
          { required: true, message: "请输入岗位", trigger: "change" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "change",
          },
        ],
        deptId: [{ required: true, message: "请选择部门", trigger: "change" }],
        birthDay: [
          { required: true, message: "请选择出生日期", trigger: "change" },
        ],
        entryTime: [
          { required: true, message: "请选择入职日期", trigger: "change" },
        ],
        roles: [{ required: true, message: "请选择角色", trigger: "change" }]
        // regularDate: [{required: true, message: "请选择转正日期", trigger: "change"}]
      },
      deptList: [],
      roleList: [],
      user: {},
      totalLeaveAnnual:"", //年假天数
      requestLeaveAnnual: "", //已请年假
      remainLeaveAnnual: "",  //剩余年假
    };
  },
  methods: {
    onSubmit() {
      this.$refs["userForm"].validate((valid) => {
        if (valid) {
          requestSaveSysUser(this.userForm).then((res) => {
            if (res.code === 200) {
              this.$message.success(res.msg);
              this.$emit("closeWindow");
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    closeWindow() {
      this.$emit("closeWindow");
    },
    getAllSysDept() {
      requestAllDept().then((res) => {
        if (res.code === 200) {
          this.deptList = res.object;
        } else {
          this.$message.error("获取部门列表失败");
        }
      });
    },
    getAllSysRole() {
      requestRoleList().then((res) => {
        if (res.code === 200) {
          this.roleList = res.object;
        } else {
          this.$message.error("获取角色列表失败");
        }
      });
    },
  },
  created() {
    this.getAllSysDept();
    this.getAllSysRole();
  },
};
</script>

<style scoped>
::v-deep .el-select-dropdown {
  position: absolute !important;
  top: 30px !important;
  left: 0px !important;
  justify-content: bw;
}
</style>
